export default __webpack_public_path__ + "static/media/tinyapp.9f5e5441.png";